// extracted by mini-css-extract-plugin
export default {"addMember":"notice_addMember__t-5uS","modalTitle":"notice_modalTitle__4aC2p","buttons":"notice_buttons__v3Dzw"};